import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import FaqCategoryItem from './FaqCategoryItem'

import './FaqCategory.scss'

function FaqCategory({ lastFaqCategoryId, handleFaqLog, categories, faqs }) {
  const FAQ_USER_PATH = 'amd_faq_user_path'
  const [activeTab, setActiveTab] = useState(lastFaqCategoryId || null)
  const [showActiveState, setShowActiveState] = useState(Boolean(lastFaqCategoryId))
  const [showResults, setShowResults] = useState(Boolean(lastFaqCategoryId))

  useEffect(() => {
    setActiveTab(lastFaqCategoryId || null)
    setShowActiveState(Boolean(lastFaqCategoryId))
    setShowResults(Boolean(lastFaqCategoryId))
  }, [lastFaqCategoryId])

  const onTabClick = categoryId => {
    window.localStorage.setItem(FAQ_USER_PATH, JSON.stringify({ id: categoryId }))
    setActiveTab(categoryId)
    setShowActiveState(true)
    setShowResults(true)
  }

  const history = useHistory()
  const setRoute = faq => {
    const {
      faqId,
      category: { description },
    } = faq
    const path = `faq/${description}/${faqId}`
    history.push(path)
    const source = 'faq category'
    handleFaqLog(faqId, source)
  }

  const safeCategories = Array.isArray(categories) ? categories : []

  return (
    <>
      <div className="FaqCategory__cardGroup">
        {safeCategories.map(item => (
          <div
            className={`FaqCategory__cardGroup__card ${
              showActiveState && String(activeTab) === String(item.id)
                ? 'FaqCategory__cardGroup__card__active'
                : ''
            }`}
            onClick={() => onTabClick(item.id)}
            onKeyDown={() => onTabClick(item.id)}
            key={`FaqCategory__card${item.id}`}
          >
            <div className="FaqCategory__cardGroup__cardDescription">
              <i className={`fas fa-${item.icon}`} />
              <div className="FaqCategory__cardGroup__cardDescriptionText">
                <h5>{item.category}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
      {showResults && (
        <FaqCategoryItem
          faqs={faqs}
          handleOnClick={faq => setRoute(faq)}
          activeTab={activeTab}
          setActiveTab
        />
      )}
    </>
  )
}

export default FaqCategory
